<template>
    <v-card class="pa-1" color="" :height="height+20" min-height="500" :outlined="outlined" flat tile>  
        <v-layout  v-if="selected_items" fill-height column class=" receipt-border ">  
            <v-simple-table class="b1 mx-1 mt-2" :height="vsh_payment_sam_table-10" fixed-header dense>
                <template v-slot:default>
                    <thead>
                        <tr class="font-weight-bold ">
                            <th class=" text-left "> 
                            </th>
                            <th class=" text-left ">
                                ITEM
                            </th>
                            <th class="text-center "> 
                                <span  > 
                                    PRICE
                                </span>
                            </th>
                            <th class="text-center ">
                                QTY
                            </th> 
                            <th class="text-center ">
                                TOTAL <span v-if="CalculatedVAT?.summary?.totalVAT">(EX VAT)</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item,index) in CalculatedVAT?.items"
                            :key="item.key" >
                            <td class="pl- text- with-divider-lr table-background1">{{ index+1 }}</td>
                            <td class="pl- text- with-divider">{{ item.name }}</td>
                            <td class=" text-right with-divider"> 
                                <span  > 
                                    {{ MBS.actions.money(item.sold_price) }}
                                </span>
                            </td> 
                            <td class=" text-center with-divider">{{ item.quantity }}</td> 
                            <td class=" text-right with-divider">{{MBS.actions.money(item.total-item.totalVAT)}} </td>
                            <!-- <td class=" text-right with-divider" style="width:40px;" >{{
                                item.taxRateId?item.taxRateId:item.tax_group_code
                            }}</td> -->
                            <td class=" text-right with-divider" style="width:40px;" >{{
                                item.rateId
                            }}</td>
                        </tr>
                        <!-- <v-divider class="mx-3"></v-divider> -->
                    </tbody>
                </template>
            </v-simple-table>
            <v-spacer></v-spacer>
            <!-- <v-divider class="mx-3"></v-divider> -->
            <v-list color="transparent" > 
                <!-- //show discount -->
                <div v-if="CalculatedVAT.summary?.TotalItemsDiscount||(CompanySettings?CompanySettings.calculate_vat:false)">
                    <v-divider class="" />  
                    <v-list-item  dense   >
                        <v-list-item-content >
                            <div class="not-f2 font-weight-bold">SUB-TOTAL</div>  
                            <div v-if="CalculatedVAT.summary?.TotalItemsDiscount" class="not-f2 font-weight-bold">DISCOUNT</div> 
                            
                        </v-list-item-content>
                        <v-list-item-action>
                            <div class="not-f2 font-weight-bold">
                                <span v-if="CalculatedVAT">
                                    <span v-if="CalculatedVAT.vat_exclusive">{{MBS.actions.money(toNumber(TotalPrice))}}</span>
                                    <span v-else>{{MBS.actions.money(toNumber(TotalPrice)-toNumber(CalculatedVAT.total_vat))}}</span> 
                                </span>
                                <span v-else>{{MBS.actions.money(TotalPrice)}}</span>
                            </div>
                            <div v-if="CalculatedVAT.summary?.TotalItemsDiscount" class="not-f2 font-weight-bold">{{MBS.actions.money(CalculatedVAT?.summary?.TotalItemsDiscount)}}</div>  
                        </v-list-item-action>   
                    </v-list-item> 
                </div>
                
                <!-- //show VAT -->
                <div v-if="CompanySettings?CompanySettings.calculate_vat:false">
                    <v-divider class=" mb-2" />
                    <span class="grey--text text--darken-2 " v-if="CalculatedVAT" > 
                        <span v-for="(rate,index) in CalculatedVAT?.summary?.taxBreakDown" >
                            <v-layout class="mx-3 ">
                                <div class="not-f2 font-weight-bold">{{MBS.actions.TEXT_UP(rate.name)}} {{rate.id}}-{{rate.rate}}%</div> 
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(rate.taxableAmount)}}</div>
                            </v-layout> 
                            <v-layout class="mx-3">
                                <div class="not-f2 font-weight-bold">VAT {{rate.id}}-{{rate.rate}}%</div> 
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(rate.taxAmount)}}</div>
                            </v-layout>   
                        </span> 

                        <v-layout class="mx-3 mt-2 mb-2 grey--text text--darken-3">
                            <div class="not-f3 font-weight-bold">TOTAL VAT</div>
                            <v-spacer/>
                            <div class="not-f3 font-weight-bold"> {{MBS.actions.money(CalculatedVAT?.summary?.totalVAT)}}</div>
                        </v-layout>   
                    </span> 
                </div>
                
                <v-divider /> 
                <v-list-item     class="grey--text text--darken-3 mx- px-2 mt-2" >
                    <v-list-item-content>
                        <v-layout class="ma-0 " align-center>
                            <div class="font-weight-bold not-f6">TOTAL PRICE:</div>
                            <!-- <div class="pl-2 font-weight-bold not-f3">{{MBS.actions.SIZE(selected_items)}} items</div>  -->
                        </v-layout>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-layout class="ma-0" align-center>
                            <div class="font-weight-bold not-f3 pt-1 pr-1">MWK </div>
                            <div class="font-weight-bold not-f6">{{MBS.actions.money(CalculatedVAT.summary.invoiceTotal)}}</div>
                        </v-layout> 
                    </v-list-item-action>   
                </v-list-item> 
            </v-list>  
        </v-layout> 
        <v-layout v-else-if="!selected_items" fill-height align-center justify-center >
            No Item
        </v-layout> 
    </v-card>
</template> 
<script> 

    import DATA from "../../../plugins/DATA"; 
    import { calculateVAT } from "../../../plugins/mra_eis";
    const PAGE_NAME = "SALE-ACTIONS"

    export default {
        props:[
            'height',"outlined","click_mode","selected_items","till","item_order","CompanySettings",
            "vsh_payment_sam_table","TotalPrice","TotalDiscount","TotalDiscountedPrice",
            "CalculatedVAT","PriceExcludeVAT","CALCULATE_PRICE","PaymentMethodsData",
            "DisabledOnAccountFields","DataSource"
        ],
        data(){
            return{
                show:false,    
                DATA:DATA,   
                 
            }
        },
        created(){ 
            try { 
                  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
            console.log(this.item_order,'item_order......');
                console.log(this.till,'till......');
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint  
                return vs
            },  
            vsh(){
                return this.vs.height
            },  
            
        },
        methods:{  
             

        },
        beforeDestroy(){
            try {    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{  
             
        }  
    }
</script> 